import { createContext } from 'react';

type AuthStatus = 'loading' | 'signedIn' | 'signedOut';

export interface AuthState {
  status: AuthStatus;
  email: string | null;
  /** Call after a successful login to refresh context state. */
  refresh: () => Promise<void>;
  signOut: () => void;
}

export const AuthContext = createContext<AuthState | null>(null);
